exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.component-fade-enter-active[data-v-5f1fa14e],\r\n.component-fade-leave-active[data-v-5f1fa14e] {\r\n    transition: opacity .2s ease;\n}\n.component-fade-enter[data-v-5f1fa14e],\r\n.component-fade-leave-to[data-v-5f1fa14e] {\r\n    opacity: 0;\n}\r\n", ""]);

// exports
